import useSharedImagesPath from "@Images/hooks/useSharedImagesPath";

function LocationToLocationBackgroundImage() {
    const desktopPath = useSharedImagesPath('images/layout/footer-bg.jpg')
    // 1×1 transparent GIF (single-pixel "spacer" image)
    const placeholderSrc = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
    return (
        <picture className="gb--navigation-background">
            {desktopPath ? (
                <img
                    className="background-image"
                    typeof="image/jpg"
                    src={desktopPath}
                    alt=""
                />
            ) : (
                <img
                    className="background-image"
                    typeof="image/gif"
                    src={placeholderSrc}
                    alt=""
                    style={{width: '100%'}}
                />
            )}
        </picture>
    )
}

export default LocationToLocationBackgroundImage